






























import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/header/UHeader.vue";
import Footer from "@/components/Footer.vue";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class UResetPassEmail extends Vue {}
